var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFlagBack = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-247.583 -283.917)" },
                React.createElement("g", { transform: "translate(244.333 282.833)" },
                    React.createElement("path", { d: "M7.4,17.6c0,0,1.1-1.1,4.3-1.1s5.4,2.2,8.7,2.2s4.3-1.1,4.3-1.1v-13c0,0-1.1,1.1-4.3,1.1\n\t\t\tS15,3.5,11.8,3.5S7.4,4.6,7.4,4.6V17.6z" }),
                    React.createElement("path", { d: "M7.4,25.2v-7.6" })),
                React.createElement("g", { transform: "translate(2 2.063)" },
                    React.createElement("path", { d: "M261.8,309.4l-2.8-2.8l2.8-2.8" }),
                    React.createElement("path", { d: "M271.4,302.5v1.4c0,1.5-1.2,2.8-2.8,2.8H259" }))))));
});
export default IconFlagBack;
//# sourceMappingURL=IconFlagBack.js.map